import React, { useEffect, useState } from "react";
import { Button, Container, Row } from 'react-bootstrap';
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Cookies, useCookies } from 'react-cookie';

import edafacelogo from "../Assets/edaface-logo1.png";
import Headermobile from "./headermobile";
import config from '../helper/config'
import { HideEmailId, isEmpty, removeLoginToken } from "../helper/common";
import { GetuserData, clostInstance } from "../Axios/user.axios";
import { useDispatch, useSelector } from "react-redux";
import { Data_Section, LogOut } from "../redux/constants";
import { FaUserCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import GTranslateWidget from "./gtranslate";
import { FiMenu } from "react-icons/fi";
import GoogleTranslate from "./gtranslate";
import { IoCartOutline } from "react-icons/io5";


let socketdata = null;
let cookieUpdated = false;

export default function Header() {

    const cookies = new Cookies();
    const navigate = useNavigate();
    const location = useLocation()
    const dispatch = useDispatch();
    const userdata = useSelector((state) => state?.LoginReducer?.User)

    const [os, setOs] = useState(null)
    const { data } = useSelector((state) => state?.LoginReducer?.Socket);

    const [showProfileMenus, setProfileMenus] = useState(false)
    // socketdata = data;

    useEffect(() => {
        socketdata = data;
    }, [data])


    const [headermobile, setHeadermobile] = useState(false)


    const cookieChangeListener = (name, value) => {
        checkCookie(config.cookiename)
    }

    function getCookie(cookieName) {
        let name = cookieName + '=';
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }

    async function checkCookie(cookieName) {
            
            let cookie = getCookie(cookieName);
            console.log('cookieName', cookieName,cookie)
            if(cookieUpdated == false){
                if (isEmpty(cookie)) {
                    navigate("/");
                    toast.success('LogOut Successfully')
                    dispatch({
                        type: LogOut,
                    })
                    dispatch({
                        type : "Socket",
                        "Socket":{
                          "Socket":{
                            data : {},
                            connected : false
                          }
                        }
                    })
                }
                else {
                    // navigate('/login')
                }
            }
            cookieUpdated = true;
            setTimeout(()=>{
                cookieUpdated = false;
            },2000)
    }
    const userAgent = window.navigator.userAgent;
    const everTarget = os === 'MacOS' ? document : window
    useEffect(() => {
        const getOS = () => {
            if (userAgent.includes('Win')) return 'Windows';
            if (userAgent.includes('Mac')) return 'MacOS';
            if (userAgent.includes('Linux')) return 'Linux';
            if (userAgent.includes('Android')) return 'Android';
            if (userAgent.includes('iPhone') || userAgent.includes('iPad')) return 'iOS';
            return 'Unknown OS';
        };
        setOs(getOS())
    }, []);
    var isOnIos = userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)
    var eventName = isOnIos ? 'pagehide' : 'beforeunload'



    useEffect(() => {
        const handleBeforeUnload = async (event) => {
            clostInstance({ id: socketdata?._id })
        };
        everTarget.addEventListener(eventName, handleBeforeUnload);
        return () => {
            everTarget.removeEventListener(eventName, handleBeforeUnload);
        };
    }, [])


    useEffect(() => {
        let initcookie = cookies.get(config.cookiename);
        if (initcookie) {
            // if(location.pathname!="/verification"){header_profile_wrapper
            //     navigate('/login')
            // }
            GetUser(initcookie)
        }
        else {
            // navigate('/')
        }
        cookies.addChangeListener(()=>{if(initcookie)cookieChangeListener()});
    }, [])

    const GetUser = async (cookie) => {
        try {
            let Resp = await GetuserData({ data: cookie });
            if (Resp?.data) {
                dispatch({
                    type: Data_Section,
                    Register_Section: {
                        User: {
                            payload: Resp?.data,
                            token: cookie
                        },
                    }
                })
            }
            else {
                removeLoginToken();
                // if (config.domainname == 'localhost') {
                //     document.cookie = config.cookiename + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                // }
                // else {
                //     document.cookie = config.cookiename + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" + config.domainname + ";";
                // }
                dispatch({
                    type: Data_Section,
                    Register_Section: {
                        User: {
                            payload: false,
                            token: false,
                        },
                    }
                })
                toast.error(Resp?.msg)
                navigate('/')
            }
            console.log('GetuserData_resp', Resp)
        }
        catch (err) {
            console.log('GetUser_error', err)
        }
    }

    const LogoutAction = () => {
        removeLoginToken();
        // if (config.domainname == 'localhost') {
        //     document.cookie = config.cookiename + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        // }
        // else {
        //     document.cookie = config.cookiename + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" + config.domainname + ";";
        // }
        dispatch({
            type: LogOut,
        })
        navigate("/");
        // toast.success('LogOut Successfully')
    }

    // useEffect(() => {
    //     // Adding the gtranslateSettings script to the window object
    //     const addGTranslateSettings = () => {
    //       window.gtranslateSettings = {
    //         default_language: "en",
    //         languages: ["en", "it", "hi", "tr", "af", "da", "ar", "pt", "zu", "zh-CN", "tl", "nl", "ha", "sv", "ja", "de"],
    //         wrapper_selector: ".gtranslate_wrapper"
    //       };
    //     };
    
    //     // Function to add the GTranslate script
    //     const addGTranslateScript = () => {
    //       const script = document.createElement('script');
    //       script.src = "https://cdn.gtranslate.net/widgets/latest/popup.js";
    //       script.defer = true;
    //       document.body.appendChild(script);
    //     };
    
    //     // Set gtranslateSettings and add the script
    //     addGTranslateSettings();
    //     addGTranslateScript();
    
    //     return () => {
    //       // Cleanup if the component unmounts
    //       const script = document.querySelector('script[src="https://cdn.gtranslate.net/widgets/latest/popup.js"]');
    //       if (script) {
    //         document.body.removeChild(script);
    //       }
    //     };
    //   }, []);


    return (

        <>
        
            {headermobile && <Headermobile onDismiss={() => setHeadermobile(false)} />}
            <div>

                <header className="header py-0 pb-2 sticky-bar">
                {/* <div class="gtranslate_wrapper"></div> */}
                    <div className="first_head">            
                    <div className="container d-flex justify-content-end pt-3">
                        {/* <p>Bringing New Insight For Your Financial Freedom!</p> */}
                        {
                            isEmpty(userdata?.payload)
                            ?
                            (<div className="font-sm d-flex align-items-center gap-3">
                                <Link className="d-flex align-items-center gap-1" to="https://launchpad.edaface.com/login" target="_blank"> <IoCartOutline className="font-lg" /> Buy EDA Coin </Link>
                                <Link className="me-2" to="/login">Login</Link>
                            </div>)
                            :
                            <Link className="me-2" to="/profile">{HideEmailId(userdata?.payload?.EmailId)}</Link>
                        }
                    </div>
                    </div>
                    <div className="container">
                        <div className="main-header">
                            <div className="header-left">
                                <div className="header-logo">
                                    <Link className="d-flex" to="https://edaface.com/" target="_blank"><img src={edafacelogo} className="logos" alt="logos" /></Link>
                                </div>

                                <div className="header-nav">

                                    <nav className="nav-main-menu d-none d-xl-block">
                                        <div className="ruby-menu-demo-header">
                                            <div className="ruby-wrapper">
                                                <ul className="ruby-menu">
                                                    <li>
                                                        <Link to="https://edaface.com/cryptocurrencies" target="_blank">Cryptocurrencies</Link>
                                                        <ul className="">
                                                            <li><Link to="https://edaface.com/coin-ranking" target="_blank">Coin Ranking</Link></li>
                                                            <li><Link to="https://edaface.com/trending" target="_blank">Trending</Link></li>
                                                            <li><Link to="https://edaface.com/eda-coin" target="_blank">EDA Coin</Link></li>
                                                            {/*<li><Link to="https://home.edaface.com/classification">Classification</Link></li>
                                                             <li><Link to="https://home.edaface.com/trending">Trending</Link></li>
                                                            <li><Link target="_blank" to="https://launchpad.edaface.com/login">EDA Token</Link></li>
                                                            <li><Link target="_blank" to="https://p2pmarket.edaface.com/">P2P Trading</Link></li> */}
                                                        </ul>
                                                        <span className="ruby-dropdown-toggle"></span>
                                                    </li>

                                                    <li>
                                                        <Link to="https://edaface.com/exchanges" target="_blank">Exchanges</Link>
                                                        <ul className="">
                                                            {/* <li><Link to="https://edaface.com/cex-listing" target="_blank">Cex Listing</Link>
                                                            </li> */}
                                                            <li class="ruby-open-to-left">
                                                                <Link to="https://edaface.com/cex-listing" target="_blank">Cex Listing</Link>
                                                                <ul>
                                                                    <li><Link to="https://edaface.com/cex-spot" target="_blank">Cex Spot</Link></li>
                                                                    <li><Link to="https://edaface.com/cex-derivatives" target="_blank">Cex Derivatives</Link></li>
                                                                </ul>
                                                                <span class="ruby-dropdown-toggle"></span>
                                                            </li>
                                                            {/* <li><Link to="https://edaface.com/dex-listing" target="_blank">Dex Listing</Link></li> */}
                                                            <li class="ruby-open-to-left">
                                                                <Link to="https://edaface.com/dex-listing" target="_blank">Dex Listing</Link>
                                                                <ul>
                                                                    <li><Link to="https://edaface.com/dex-spot" target="_blank">Cex Spot</Link></li>
                                                                    <li><Link to="https://edaface.com/dex-derivatives" target="_blank">Cex Derivatives</Link></li>
                                                                </ul>
                                                                <span class="ruby-dropdown-toggle"></span>
                                                            </li>
                                                            <li><Link to="https://edaface.com/dex" target="_blank">EdaFace Dex</Link></li>
                                                            {/* <li><Link to="https://home.edaface.com/spot">Spot</Link></li>
                                                            <li><Link to="https://home.edaface.com/derivatives">Derivatives</Link></li>
                                                            <li><Link to="https://home.edaface.com/dex">Dex</Link></li>
                                                            <li><Link to="https://home.edaface.com/eda-plantation">Eda Plantation</Link></li> */}
                                                        </ul>
                                                        <span className="ruby-dropdown-toggle"></span>
                                                    </li>

                                                    <li>
                                                        <Link to="https://edaface.com/verification-centre" target="_blank">Verification Centre</Link>
                                                        <ul className="">
                                                            <li><Link to="https://edaface.com/rug-pull-check" target="_blank">Scam Verification</Link></li>
                                                            <li><Link to="https://edaface.com/list-your-projects" target="_blank">List Your Projects</Link></li>
                                                            <li><Link to="https://edaface.com/edaface-launchpad" target="_blank">EdaFace Launchpad</Link></li>
                                                            {/* <li><Link to="https://home.edaface.com/rug-pull-check">Rug Pull Check</Link></li>
                                                            <li><Link to="https://home.edaface.com/blockchain-ecosystem">Blockchain Ecosystem</Link></li>
                                                            <li><Link target="_blank" to="https://launchpad.edaface.com/">Launchpad</Link></li> */}
                                                        </ul>
                                                        <span className="ruby-dropdown-toggle"></span>
                                                    </li>

                                                    <li>
                                                        <Link to="https://edaface.com/market-places" target="_blank">Market Places</Link>
                                                        <ul className="">
                                                            <li><Link target="_blank" to="https://edaface.com/nft-market-place">NFT Marketplace</Link></li>
                                                            <li><Link target="_blank" to="https://edaface.com/blockchain-literature">Blockchain Literature</Link></li>
                                                            <li><Link target="_blank" to="https://edaface.com/edaface-mall">EdaFace Mall</Link></li>
                                                            <li><Link target="_blank" to="https://edaface.com/p2pmarket">P2P Market</Link></li>
                                                            <li><Link target="_blank" to="https://edaface.com/metaverse">Metaverse</Link></li>
                                                            {/* <li><Link target="_blank" to="https://nft.edaface.com/">NFT Marketplace</Link></li>
                                                            <li><Link to="https://home.edaface.com/digital-literature">Digital Literature</Link></li>
                                                            <li><Link target="_blank" to="https://mall.edaface.com/">Digital Mall</Link></li>
                                                            <li><Link to="https://home.edaface.com/metaverse">Metaverse</Link></li> */}
                                                        </ul>
                                                        <span className="ruby-dropdown-toggle"></span>
                                                    </li>

                                                    <li className="ruby-menu-mega">
                                                        <Link to="https://edaface.com/academy" target="_blank">EdaFace Academy</Link>
                                                        <ul className="">
                                                            <li><Link target="_blank" to="https://edaface.com/school-of-cryptocurrencies">School of Cryptocurrencies</Link></li>
                                                            <li><Link target="_blank" to="https://edaface.com/newsfeed">EdaFace Newsfeed</Link></li>
                                                            <li><Link target="_blank" to="https://edaface.com/digital-clinic">Digital Clinic</Link></li>
                                                            <li><Link target="_blank" to="https://edaface.com/tutor">EdaFace Tutor</Link></li>
                                                            {/* <li><Link target="_blank" to="https://school.edaface.com/">School of Cryptocurrencies</Link></li>
                                                            <li><Link target="_blank" to="https://news.edaface.com/">Cryto News</Link></li>
                                                            <li><Link target="_blank" to="https://p2pmarket.edaface.com/">Digital Clinic</Link></li> */}
                                                        </ul>
                                                        <span className="ruby-dropdown-toggle"></span>
                                                    </li>

                                                    <li>
                                                        <Link to="https://edaface.com/resources" target="_blank">Resources</Link>
                                                        <ul>
                                                            <li class="ruby-open-to-left">
                                                                <Link to="https://edaface.com/about-edaface" target="_blank">About Us</Link>
                                                                <ul>
                                                                    <li><Link to="https://edaface.com/vision" target="_blank">Vision</Link></li>
                                                                    <li><Link to="https://edaface.com/mission" target="_blank">Mission</Link></li>
                                                                    <li><Link to="https://edaface.com/core-values" target="_blank">Core Values</Link></li>
                                                                    <li><Link to="https://edaface.com/branding" target="_blank">Branding</Link></li>
                                                                </ul>
                                                                <span class="ruby-dropdown-toggle"></span>
                                                            </li>
                                                            {/* <li><Link to="https://home.edaface.com/litepaper">Litepaper</Link></li> */}
                                                            <li>
                                                                <Link to="https://info.edaface.com/" target="_blank">How to use Edaface</Link>
                                                                {/* <ul>
                                                                    <li><Link to="https://home.edaface.com/introduction">Introduction</Link></li>
                                                                    <li class="ruby-open-to-left">
                                                                        <Link to="https://home.edaface.com/components">
                                                                            <i className="fa fa-university" aria-hidden="true"></i>
                                                                            Components</Link>
                                                                        <ul>
                                                                            <li><Link to="https://home.edaface.com/component-1">Component 1</Link></li>
                                                                            <li><Link to="https://home.edaface.com/component-2">Component 2</Link></li>
                                                                            <li><Link to="https://home.edaface.com/component-3">Component 3</Link></li>
                                                                            <li><Link to="https://home.edaface.com/component-4">Component 4</Link></li>
                                                                            <li><Link to="https://home.edaface.com/component-5">Component 5</Link></li>
                                                                            <li><Link to="https://home.edaface.com/component-6">Component 6</Link></li>
                                                                            <li><Link to="https://home.edaface.com/component-7">Component 7</Link></li>
                                                                            <li><Link to="https://home.edaface.com/component-8">Component 8</Link></li>
                                                                            <li><Link to="https://home.edaface.com/component-9">Component 9</Link></li>
                                                                        </ul>
                                                                        <span class="ruby-dropdown-toggle"></span>
                                                                    </li>
                                                                    <li><Link to="https://home.edaface.com/4-characteristics-of-edaface">4 Characteristics of Edaface</Link></li>
                                                                    <li><Link to="https://home.edaface.com/edaface-structure">Edaface Structure</Link></li>
                                                                </ul> */}
                                                                <span class="ruby-dropdown-toggle"></span>
                                                            </li>
                                                            <li class="ruby-open-to-left">
                                                                <Link to="https://info.edaface.com/knowledge-base/article/edaface-team" target="_blank">EdaFace Team</Link>
                                                                <ul>
                                                                    <li><Link to="https://info.edaface.com/knowledge-base/article/departments" target="_blank">EdaFace Departments</Link></li>
                                                                    <li><Link to="https://info.edaface.com/knowledge-base/article/board-of-managers" target="_blank">Board of Managers</Link></li>
                                                                    <li><Link to="https://info.edaface.com/knowledge-base/article/board-of-advisors" target="_blank">Board of Advisors</Link></li>
                                                                    <li><Link to="https://info.edaface.com/knowledge-base/article/partners" target="_blank">EdaFace Partners</Link></li>
                                                                    {/* <li><Link to="https://home.edaface.com/tokenamics">Tokenamics</Link></li>
                                                                    <li><Link to="https://home.edaface.com/utility-cases">Utility Cases</Link></li>
                                                                    <li><Link to="https://home.edaface.com/token-characteristics">Token Characteristicss</Link></li>
                                                                    <li><Link to="https://home.edaface.com/stakability">Stakability</Link></li>
                                                                    <li><Link to="https://home.edaface.com/ico-details">ICO Details</Link></li>
                                                                    <li><Link to="https://home.edaface.com/airdrops-bonuses">Airdrops/Bonuses</Link></li>
                                                                    <li><Link to="https://home.edaface.com/road-map">Road Map</Link></li>
                                                                    <li><Link to="https://home.edaface.com/disclaimer">Disclaimer</Link></li> */}
                                                                </ul>
                                                                <span class="ruby-dropdown-toggle"></span>
                                                            </li>
                                                            {/* <li class="ruby-open-to-left">
                                                                <Link to="https://home.edaface.com/teams-1">Team</Link>
                                                                <ul>
                                                                    <li><Link to="https://home.edaface.com/Departments">Departments</Link></li>
                                                                    <li><Link to="https://home.edaface.com/board-of-founders">Board of Founders</Link></li>
                                                                    <li><Link to="https://home.edaface.com/board-of-advisors">Board of Advisors</Link></li>
                                                                    <li><Link to="https://home.edaface.com/partners">Partners</Link></li>
                                                                </ul>
                                                                <span class="ruby-dropdown-toggle"></span>
                                                            </li> */}
                                                            <li class="ruby-open-to-left">
                                                                <Link to="https://edaface.com/faq" target="_blank">FAQ</Link>
                                                                <ul>
                                                                    <li><Link to="https://edaface.com/faq-about-team" target="_blank">FAQ about Team</Link></li>
                                                                    <li><Link to="https://edaface.com/faq-about-edaface" target="_blank">FAQ about EdaFace</Link></li>
                                                                    <li><Link to="https://edaface.com/faq-about-eda-coin" target="_blank">FAQ about EdaCoin</Link></li>
                                                                    {/* <li><Link to="https://home.edaface.com/faq-on-eda">FAQ on EDA</Link></li>
                                                                    <li><Link to="https://home.edaface.com/faq-on-edaface">FAQ on EdaFace</Link></li>
                                                                    <li><Link to="https://home.edaface.com/faq-on-eda-token">FAQ on Eda Token</Link></li> */}

                                                                </ul>
                                                                <span class="ruby-dropdown-toggle"></span>
                                                            </li>
                                                        </ul>
                                                    </li>



                                                </ul>
                                                
                                            </div>
                                        </div>
                                    </nav>
                                 
                                    {/* <div class="burger-icon burger-icon-white" onClick={() => { setHeadermobile(true) }}><span class="burger-icon-top"></span><span class="burger-icon-mid"></span><span class="burger-icon-bottom"></span></div> */}

                                </div>

                                <div class="header-right">
                                    <div className="d-flex gset align-items-center justify-content-end gap-3">
                                    {/* <div className="d-none d-xl-block"><GTranslateWidget/></div> */}
                                        {
                                            isEmpty(userdata?.payload)
                                                ?
                                                <div class="get_start_button ">
                                            <Link class="btn btn-brand-1 hover-up" to="https://edaface.com/register" target="_blank">Get Started</Link>
                                        </div>
                                                :
                                                <>
                                                    <div className="header_profile_wrapper">
                                                        <ul className="ruby-menu">
                                                            <li>
                                                                <button className="profileicon border-0 outline-0 bg-transparent">
                                                                    {
                                                                        userdata?.payload?.Profile 
                                                                        ?
                                                                        <img src={`${config.Img_URL}/profile/${userdata?.payload?._id}/${userdata?.payload?.Profile}`} />
                                                                        :
                                                                        <FaUserCircle />
                                                                    }
                                                                </button>
                                                                <ul className="profile_dropdowns">
                                                                    <li className="text-start">
                                                                        <Link to="/profile">Profile</Link></li>
                                                                    <li className="text-start">
                                                                        <button className="bg-transparent outline-0 border-0" onClick={()=>LogoutAction()}>Logout</button>
                                                                    </li>
                                                                </ul>
                                                                <span className="ruby-dropdown-toggle"></span>
                                                            </li>

                                                        </ul>
                                                    </div>

                                                </>
                                        }
                                         <div class="burger-icon burger-icon-white" onClick={() => { setHeadermobile(true) }}>
                                            {/* <span class="burger-icon-top"></span><span class="burger-icon-mid"></span><span class="burger-icon-bottom"></span> */}
                                          <FiMenu/>
                                            </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div >
                </header >

            </div >


        </>
    );
}
